<template>
    <!-- More information about GAPS here: https://w.amazon.com/bin/view/Pumas-team/OurOfferings/AccountSwitchers -->
    <template v-if="showBusinessUnitSelector">
        <div
            class="dropdown-account-switcher-container"
            data-design-system="core"
            data-experience="businessUnit"
            data-mode="globalOnly"
            data-test-tag="dropdown-account-switcher-container-globalOnly"
        >
            <a
                class="account-switcher-fallback"
                href="/account-switcher/default/vendorGroup/businessUnit"
                data-test-tag="account-switcher-fallback"
            >
                {{ $t('header_accountSwitcher_switchAccounts') }}
            </a>
        </div>
        <div
            class="dropdown-account-switcher-container"
            data-design-system="core"
            data-experience="businessUnit"
            data-mode="regionalOnly"
            data-nature="vendorGroup"
            data-test-tag="dropdown-account-switcher-container-regionalOnly"
        />
    </template>
    <div
        v-else
        class="dropdown-account-switcher-container"
        data-mode="default"
        data-nature="vendorGroup"
        data-test-tag="dropdown-account-switcher-container"
    >
        <a
            class="account-switcher-fallback"
            href="/account-switcher/default/vendorGroup"
            data-test-tag="account-switcher-fallback"
        >
            {{ $t('header_accountSwitcher_switchAccounts') }}
        </a>
    </div>
</template>

<script>
import getWeblabTreatment, { Treatment } from '../util/getWeblabTreatment';

export default {
    name: 'AccountSwitcherLoader',
    computed: {
        showBusinessUnitSelector() {
            return getWeblabTreatment('PUMAS_GAPS_BUSINESS_UNIT_SELECTOR_1459150') === Treatment.T1;
        },
    },
    methods: {
        appendScriptsToDom() {
            const idPrefix = 'dropdown-account-switcher-loader';
            const scriptEl = document.createElement('script');
            scriptEl.id = `${idPrefix}-script`;
            scriptEl.src = '/account-switcher/dropdown-assets-loader.js';
            scriptEl.setAttribute('data-test-tag', `${idPrefix}-script`);
            document.head.appendChild(scriptEl);
        },
    },
    mounted() {
        this.appendScriptsToDom();
    },
};
</script>

<style lang="scss" scoped>
$grid-breakpoint-md: 1064px;

.dropdown-account-switcher-container {
    align-items: center;
    display: flex;
    height: 48px;
    padding: 0 16px;

    --gaps-dropdown-header-max-width: 320px;

    @media (width >= $grid-breakpoint-md) {
        --gaps-dropdown-header-max-width: 400px;
    }

    &[data-mode='regionalOnly'] {
        border-left: 1px $kat-squid-ink-500 solid;
    }
}

.account-switcher-fallback {
    font-size: 12px;
    line-height: 16px;
}
</style>
